module.exports = __webpack_public_path__ + "img/milestone-asset-3.36ba3e4f.png";